import { useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import FaceIcon from "@mui/icons-material/Face";
import Chip from "@mui/material/Chip";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

import Tooltip from "@mui/material/Tooltip";
import CreateTicket from "./CreateTicket/CreateTicket";
import ManageTickets from "./ManageTickets/ManageTickets";

export default function Tickets(props) {
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [ticketTab, setTicketTab] = useState("ManageTickets");

  const handleTicketsTabs = (e) => {
    setTicketTab(e.currentTarget.value);
  };

  const selectedTabContent = (selected) => {
    switch (selected) {
      case "ManageTickets":
        return <ManageTickets />;
      case "CreateTicket":
        return <CreateTicket />;
      default:
        return "مشکلی وجود دارد";
    }
  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Box sx={{ width: "100%", px: 1 }}>
        {/* <Chip sx={{mt:1}}  color="success"  icon={<FaceIcon />} label="اطلاعات ورود" /> */}
        <Tooltip title="لیست تیکت ها" arrow>
          <Button
            value="ManageTickets"
            onClick={handleTicketsTabs}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={ticketTab == "ManageTickets" ? "error" : "warning"}
              icon={<FaceIcon />}
              label={detectSize600px ? "لیست تیکت ها" : ""}
            />
          </Button>
        </Tooltip>
        <Tooltip title="ثبت تیکت جدید" arrow>
          <Button
            value="CreateTicket"
            onClick={handleTicketsTabs}
            sx={{ mt: 1 }}
          >
            <Chip
              clickable
              color={ticketTab == "CreateTicket" ? "error" : "warning"}
              icon={<ManageAccountsIcon />}
              label={detectSize600px ? "ثبت تیکت جدید" : ""}
            />
          </Button>
        </Tooltip>
        <hr />
        {selectedTabContent(ticketTab)}
      </Box>
    </Grid>
  );
}
